import React, { useEffect, useState, useRef } from 'react'
import mainlogo from "../../Assets/images/main-logo.svg"
import microsoft from "../../Assets/images/microsoft.svg"
import google from "../../Assets/images/google.svg"
import apple from "../../Assets/images/apple-icon.svg"
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import LoginValidation from '../../Validation/LoginValidation'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import { useNavigate } from 'react-router-dom'
import { deleteFromStorage, getFromStorage, handleBackspaceAndEnter, saveToStorage } from '../../utils/Helper'
import { StorageConstant, VALIDATION_MESSAGE } from '../../constants/Constants'
import ResetPassword from '../../Modal/ResetPassword'
import { Config } from '../../config/Config'
import FrontLoader from '../layout/FrontLoader'
import { LanguageConstants } from '../../constants/LanguageConstants'
import SocialLogin from '../layout/SocialLogin'


interface FormInputs {
  email: string;
  password: string;
};
function Login() {
  const Login = useMakeRequest()
  const Forgot = useMakeRequest()
  const ResedOtp = useMakeRequest()
  const OTP = useMakeRequest()
  const numberOfDigits = 4;
  const regex = /^[0-9\b]+$/;
  const otpBoxRef = useRef<any>([]);
  const [forgotpopu, setForgotpopu] = useState(false)
  const [otppopu, setOtpPopu] = useState(false)
  const [resetPopu, setResetPopu] = useState(false)
  const [show, setShow] = useState(false)
  const [forgotemail, setForgotemail] = useState('')
  const [forgotEmailerror, setForgotemailerror] = useState('')
  const [otpData, setOtpData]: any = useState('')
  const [otpError, setOtpError] = useState('');
  const [otp, setOtp]: any = useState(new Array(numberOfDigits).fill(""));
  const [timer, setTimer] = useState(120);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const navigate = useNavigate()
  let countdown: any;
  const rememberMe = getFromStorage({ key: StorageConstant?.remember_me});

  const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
    mode: 'onChange',
    resolver: yupResolver(LoginValidation),
  });


  const onSubmit = (payload: FormInputs) => {
    setResetPopu(false)
    setForgotpopu(false)
    setOtpPopu(false)
    setShow(false)
    Login.makeRequest({ payload, url: ApiConstants?.Login, toastStatus: true })
  }
  const handelForgotEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!forgotemail) {
      setForgotemailerror('Please enter email')
    }
    else if (!emailRegex.test(forgotemail)) {
      setForgotemailerror('Please enter a valid email');
    }
    else {
      const payload = {
        email: forgotemail
      }
      Forgot.makeRequest({ payload, url: ApiConstants?.ForgotPassword, toastStatus: true })
    }
  }

  const onPaste = (event: any) => {
    const pasted = event.clipboardData.getData("text/plain")
    if (pasted.length === numberOfDigits && regex.test(pasted)) {
      setOtpError('')
      setOtpData(pasted)
      setOtp(pasted.split("").slice(0, numberOfDigits))
    }

  }
  const handleChange = (value: any, index: any) => {
    setOtpError('')
    if (value === '' || regex.test(value)) {
      let newArr = [...otp];
      newArr[index] = value;
      setOtp(newArr);
      setOtpData(newArr.join(''))

    }

    if (value && regex.test(value) && index < numberOfDigits - 1) {
      otpBoxRef.current[index + 1].focus();
    }
  }
  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      // handleVerify()
    }
  }
  const handleVerifyOtp = () => {
    if (otp.join("") == "" || otpData?.length < 4) {
      return setOtpError('Please enter OTP.')
    }
    setOtpError('');
    let payload = {
      email: forgotemail,
      otp: otpData,
      verify_type: "FORGOT_PASSWORD"
    }
    OTP.makeRequest({ payload, url: ApiConstants?.VerifyOtp, toastStatus: true })
  }
  const handleShowChange = () => {
    setResetPopu(false);
    setForgotpopu(false)
    setOtpPopu(false)
    setShow(false)
  };

  useEffect(() => {
    if (Forgot.status) {
      setForgotemailerror('')
      setForgotpopu(false)
      setOtpPopu(true)
      setIsTimerRunning(false)
      setIsTimerRunning(true)
      setTimer(120)
    }
    if (OTP.status) {
      setForgotemailerror('')
      setOtpError('')
      setOtpPopu(false)
      setResetPopu(true)
    }
  }, [Forgot?.status, OTP?.status])
  useEffect(() => {
    if (isTimerRunning && timer > 0) {
        countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);
    } else if (timer === 0) {
        clearInterval(countdown);
        setIsTimerRunning(false);
    }
    return () => {
        clearInterval(countdown);
    };
}, [isTimerRunning, timer ,ResedOtp.status]);

useEffect(()=>{
  if(rememberMe){
    setValue('email',rememberMe?.email ? rememberMe?.email : '')
    setValue('password',rememberMe?.password ? rememberMe?.password : '')
  }
if(ResedOtp.status){
  setIsTimerRunning(true)
  setTimer(120)
}
},[ResedOtp?.status])

useEffect(()=>{
  if (Login?.status) {
    setResetPopu(false);
    setForgotpopu(false)
    setOtpPopu(false)
    setShow(false)
    saveToStorage({ key: "access_token", value: Login?.data?.access_token })
    saveToStorage({ key: "user_data", value: Login?.data })
    window.location.href = `${Config?.BASE_URL}/`;
  }
},[Login?.status])

const handelResendOtp =()=>{
  const payload ={
    email:forgotemail,
    verify_type:'FORGOT_PASSWORD'
  }
  ResedOtp.makeRequest({ payload, url: ApiConstants?.ResendOtp, toastStatus: true })
}

const handelRemberMe =()=>{
  const check :any = document.getElementsByClassName('form-check-input')
if(check?.rememberMe?.checked){
  if(watch('email') &&  watch('password')){
    const data ={
      email : watch('email'),
      password: watch('password')
    }
    saveToStorage({ key: "remember_me", value: data })
  }
}else{
  deleteFromStorage({key:"remember_me"})
}

}

  return (
    <>
    {(Forgot?.loading || Login?.loading || ResedOtp?.loading || OTP?.loading) ? <FrontLoader/> :null}
      <div className="auth-page">
        <div className="auth-page-form">
          <div className="auth-form-inner">
            <a className="auth-logo" href={`${Config?.BASE_URL}/`}><img src={mainlogo} /></a>
            <h1 className="auth-title">{LanguageConstants?.LOGIN}</h1>
            <p className="auth-head-para">{LanguageConstants?.ENTER_YOUR_LOGIN_DETAILS}</p>
            <form onSubmit={handleSubmit(onSubmit)} >
              <div className='mb-4'>
              <div className="com-floating">
                <i className="f-icon icon-msg" />
                <label className="f-label">{LanguageConstants?.LOGIN_EMAIL_ADDRESS}</label>
                <input className="f-input" type="email" placeholder={LanguageConstants?.LOGIN_EMAIL_ADDRESS_TEXT} {...register('email')} />
              </div>
                <ErrorMessage
                  errors={errors}
                  name="email"
                  render={({ message }) => <p className='text-error'>{message}</p>}
                />

              </div>
              <div className='mb-4'>

              <div className="com-floating">
                <i className="f-icon icon-lock" />
                <label className="f-label">{LanguageConstants?.PASSWORD}</label>
                <input className="f-input" type={show ? "text" : "password"} placeholder={LanguageConstants?.PASSWORD} {...register('password')} />
                <i className={show ? "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={() => setShow(!show)} />
              </div>
                <ErrorMessage
                  errors={errors}
                  name="password"
                  render={({ message }) => <p className='text-error'>{message}</p>}
                />
              </div>
              <div className="form-label-area">
                <div className="form-check" onClick={(e:any)=>handelRemberMe()} >
                  <input className="form-check-input" type="checkbox" id="rememberMe" defaultChecked={rememberMe ? true :false} />
                  <label className="form-check-label" htmlFor="rememberMe">
                    {LanguageConstants?.REMEBER_ME}
                  </label>
                </div>
                <button className="auth-modal-btn" type="button" onClick={() => setForgotpopu(true)} >{LanguageConstants?.FORGOT_PASSWORD}?</button>
              </div>

              <button className="com-btn w-100 form-submit-btn">{LanguageConstants?.LOGIN}</button>
              <div className="small-txt text-center mt-5">{LanguageConstants?.GUEST_USER}    <Link to={'/'} className="theme-color" >{LanguageConstants?.GUEST}</Link></div>
                 <SocialLogin/>
              <div className="small-txt text-center mt-5">{LanguageConstants?.LOGIN_MESSAGE}    <Link to={'/signup'} className="theme-color" >{LanguageConstants?.SINGUP}</Link>
              </div>
            </form>
          </div>
        </div>
        <div className="auth-page-bnr" />
      </div>

      {/* <!-- forgot password modal  --> */}
      <Modal show={forgotpopu}>
        <div className="modal fade auth-modal text-center show" id="forgotPassModal" aria-labelledby="forgotPassModalLabel" aria-hidden="false" style={{ display: 'block' }} >

          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <button type="button" onClick={() =>{ setForgotpopu(false) ; setForgotemail('')}} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
              <div className="modal-body">
                <h5 className="auth-modal-ttl">{LanguageConstants?.FORGOT_PASSWORD}</h5>
                <div className='mb-4'>
                <div className="com-floating">
                  <i className="f-icon icon-msg" />
                  <label className="f-label">{LanguageConstants?.LOGIN_EMAIL_ADDRESS}</label>
                  <input className="f-input ps-5" type="email" placeholder={LanguageConstants?.LOGIN_EMAIL_ADDRESS_TEXT} onChange={(e) => setForgotemail(e?.target?.value)} />
                </div>
                  <p className='text-error text-start'>{forgotEmailerror}</p>

                </div>
                <button type="button" style={{marginTop:'25px'}} disabled={Forgot.loading ? true : false}  onClick={() => handelForgotEmail()} className="round-btn" data-bs-dismiss="modal">{LanguageConstants?.SEND_OTP}</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* <!-- forgot password modal  --> */}


      {/* <!-- OTP verify modal --> */}
      <Modal show={otppopu}>
        <div className="modal fade auth-modal text-center show" id="forgotPassModal" aria-labelledby="forgotPassModalLabel" aria-hidden="false" style={{ display: 'block' }} >

          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <button type="button" onClick={() => {setOtpPopu(false) ; setForgotemail('')}} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square"></i></button>
              <div className="modal-body">
                <h5 className="auth-modal-ttl mb-2">{LanguageConstants?.OTP_VERIFICATION}</h5>
                <p className="auth-modal-small-txt">{LanguageConstants?.ENTER_OTP_DIGIT}  ****{forgotemail?.split('@')[1]}</p>
                <div className="otp-inputs">
                  {
                    otp.map((digit: any, index: any) => {
                      return (
                        <input className='form-control' key={index}
                          value={digit} onPaste={onPaste} maxLength={1} ref={(ref) => (otpBoxRef.current[index] = ref)}
                          type="text"
                          placeholder="*"
                          onChange={(e) => handleChange(e.target.value, index)}
                          onKeyDown={handleKeyDown}
                          onKeyUp={(e) => handleBackspaceAndEnter(e, index, otpBoxRef, numberOfDigits)}
                        />
                      )
                    })
                  }
                </div>
                <p style={{ color: 'red' }} >{otpError}</p>
                <p className="auth-modal-small-txt mb-2">{LanguageConstants?.DONT_RECIVE_CODE}?</p>
                {isTimerRunning ?  
                <div className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4">{LanguageConstants?.RESEND_IN} :{timer} s</div>
                :
                <button className="auth-modal-small-txt border-0 fw-500 p-0 bg-transparent theme-color mb-4" onClick={()=>handelResendOtp()}>{LanguageConstants?.RESEND_OTP}</button>
                }
                <button type="button" disabled={OTP.loading ? true : false} onClick={handleVerifyOtp} className="auth-modal-btn round-btn mt-4 w-50 d-block mx-auto" data-bs-dismiss="modal">{LanguageConstants?.VERIFY}</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* <!-- OTP verify modal --> */}

      {/* <!-- Reset password modal --> */}
      <Modal show={resetPopu}>
        <ResetPassword email={forgotemail} OTP={otp} setShowFalse={handleShowChange} />
      </Modal>
      {/* <!-- Reset password modal --> */}

    </>
  )
}

export default Login